import React from 'react';
import { Icon, IconProps } from './Icon';

export const PlayIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon viewBox="0 0 18 18" width={18} height={18} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5548 11.3183L9.64063 5.58362C9.48034 5.39666 9.24636 5.28906 9.00009 5.28906C8.75382 5.28906 8.51984 5.39666 8.35954 5.58362L3.4454 11.3183C2.97642 11.8657 3.36525 12.7112 4.08595 12.7112H13.9156C14.6363 12.7112 15.0252 11.8657 14.5548 11.3183Z"
        fill="#808080"
      />
    </Icon>
  );
};
